<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const props = defineProps({
  data: Object,
  isLoading: Boolean,
});

const store = useStore();
const { t } = useI18n();

const clickedButtonTopTen = computed(
  () => store.getters["clickedButton/getClickedButtonTopTen"],
);
const name = computed(() =>
  clickedButtonTopTen.value === "technologyCards"
    ? t("top_ten_headers.tech_card")
    : clickedButtonTopTen.value === "contractors"
      ? t("top_ten_headers.contractor")
      : t("top_ten_headers.structure"),
);

const topTenHeaders = [
  { title: t("top_ten_headers.num"), key: "num", maxWidth: "50px" },
  {
    title: name,
    key: "name",
    align: "start",
    width: "700px",
  },
  {
    title: t("top_ten_headers.deviations_count"),
    key: "count",
    align: "center",
  },
  {
    title: t("top_ten_headers.weight_in_structure"),
    key: "percent",
    align: "center",
  },
];
</script>

<template class="custom-table">
  <v-card>
    <v-data-table
      :headers="topTenHeaders"
      :items="props.data"
      class="table"
      height="260px"
      fixed-header
      hide-default-footer
      :loading="props.isLoading"
      :items-per-page="-1"
      :loading-text="t('loading_text')"
    >
      <template v-slot:no-data>
        <div class="text-center">
          <p>{{ t("No_data_text") }}</p>
        </div>
      </template>
      <template v-slot:[`item.percent`]="{ item }">
        <span> {{ item.percent?.toFixed(2) }}% </span>
      </template>
    </v-data-table>
  </v-card>
</template>

<style scoped>
:deep(::-webkit-scrollbar-track) {
  margin-top: 50px;
  margin-bottom: 0;
}
.v-data-table {
  background: #09182e;
  font-size: 22px;
}
:deep(.v-data-table thead th) {
  background: #09182e !important;
  color: #00a3ff;
}
:deep(tbody tr:nth-of-type(even)) {
  background: #212f42 !important;
}
:deep(tbody tr:nth-of-type(odd)) {
  background: #09182e !important;
}
:deep(.v-data-table tbody tr:hover) {
  opacity: 0.7;
  transition: opacity 0.3s ease;
}
@media (max-height: 710px) {
  .v-data-table {
    font-size: 18px;
  }
  .table {
    height: 21vh !important;
  }
}
@media (min-height: 710px) and (max-height: 760px) {
  .v-data-table {
    font-size: 19px;
  }
  .table {
    height: 24vh !important;
  }
}
@media (min-height: 760px) and (max-height: 810px) {
  .v-data-table {
    font-size: 19px;
  }
  .table {
    height: 28vh !important;
  }
}
@media (min-height: 810px) and (max-height: 860px) {
  .v-data-table {
    font-size: 19px;
  }
  .table {
    height: 32vh !important;
  }
}
@media (min-height: 860px) and (max-height: 900px) {
  .table {
    height: 29vh !important;
  }
}
@media (min-height: 900px) and (min-width: 2000px) {
  .table {
    height: 18vh !important;
  }
}
</style>
